import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fallbackEnToDe',
    standalone: false
})
export class FallbackEnToDePipe implements PipeTransform {

  transform(lang: string): string {
    if(!lang) {
      return 'de';
    }

    return lang === 'en' ? 'de' : lang;
  }

}
